module.exports = __webpack_public_path__ + "img/ball.0f5f2f.svg";